import { defineStore } from "pinia";
import reportsService from "@/services/reports.service";
import { toast } from "@/utils/toast";

function errMsg(err) {
  return err?.response?.data?.message || err?.message || "Unexpected error";
}

export const useAuditTrailStore = defineStore("auditTrail", {
  state: () => ({
    rows: [],
    total: 0,
    pageSize: 25,
    current: 1,
    loading: false,
    summary: null,
    error: null,
  }),

  actions: {
    async fetchAuditTrail(params = {}) {
      if (this.loading) return;
      this.loading = true;
      this.error = null;
      try {
        const { data } = await reportsService.auditTrail(params);
        const rows = data.rows || {};
        this.rows = rows.data || [];
        this.total = rows.total || 0;
        this.pageSize = rows.per_page || params.per_page || 25;
        this.current = rows.current_page || params.page || 1;
        this.summary = data.summary || null;
        return data;
      } catch (err) {
        this.error = errMsg(err);
        toast(this.error, "error");
        throw err;
      } finally {
        this.loading = false;
      }
    },

    async exportAuditTrail(format = "csv", params = {}) {
      try {
        const svc =
          format === "pdf"
            ? reportsService.exportAuditTrailPDF
            : reportsService.exportAuditTrailCSV;

        const res = await svc(params);

        const mime =
          format === "pdf" ? "application/pdf" : "text/csv;charset=utf-8";

        const blob = new Blob([res.data], { type: mime });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");

        const from = params.from || "start";
        const to = params.to || "end";
        const ext = format === "pdf" ? "pdf" : "csv";

        a.href = url;
        a.download = `audit-trail-${from}_to_${to}.${ext}`;
        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
      } catch (err) {
        toast(errMsg(err), "error");
        throw err;
      }
    },
  },
});
